<mat-tab-group [selectedIndex]="selectedIndex" (selectedIndexChange)="onSelectedIndexChange($event)">
    @for(choice of choicesArray ; track choice.key) {
        <mat-tab  [label]="choice.value.label">
            <ng-template  mat-tab-label>
                @if(choice.value.icon) {
                    <mat-icon svgIcon="{{choice.value.icon}}"></mat-icon>
                }

                <span>{{choice.value.label | translate}}</span>

                @for(suffixIcon of choice.value.suffixIcons; track suffixIcon) {
                    <mat-icon svgIcon="{{suffixIcon}}"></mat-icon>
                }

            </ng-template >

<!--        <ng-template  matTabContent>-->
<!--            <ng-content select="[data-data-matTabContent]"></ng-content>-->
<!--        </ng-template>-->
        </mat-tab>
    }
</mat-tab-group>